import { TierName } from '../../types/ranked';

/**
 * Tier colours.
 *
 * Deliberately fixed rather than derived from the theme. An earlier version read
 * Gold from `palette.tertiary`, on the assumption that a tenant which rebrands
 * would get a matching ladder for free — but the branding slots do not have a
 * stable meaning: V17__create_tenant_branding_defaults.sql swaps secondary and
 * tertiary for the MathWiz tenant, so `tertiary.main` is green there and "Gold I"
 * rendered green.
 *
 * A rank ladder is semantic, not brand chrome — the same reason the medal colours
 * on LeaderboardPage are fixed. These values match the reviewed design, where they
 * happen to coincide with the default tenant's palette (Platinum is the brand
 * blue, Diamond the brand accent) without depending on it.
 */
const TIER_COLORS: Record<TierName, string> = {
  bronze: '#CD7F32',
  silver: '#90A4AE',
  gold: '#F39C12',
  platinum: '#2B3990',
  diamond: '#9C27B0'
};

export const tierColor = (tier: TierName): string => TIER_COLORS[tier] ?? TIER_COLORS.bronze;

/** Medal colours for the top three positions, matching LeaderboardPage. */
export const medalColor = (rank: number): string | null => {
  if (rank === 1) return '#FFD700';
  if (rank === 2) return '#C0C0C0';
  if (rank === 3) return '#CD7F32';
  return null;
};
